import { makeStyles } from "@material-ui/core/styles";
export const cardImageWidth = 300;
export const cardImageHeight = 190;
export const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
    },
    card: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    cardMain: {
        padding: theme.spacing(1),
        flex: '1 0',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
    },
    cardActions: {
        display: "flex",
        flexFlow: "column",
        [theme.breakpoints.down('sm')]: {
            marginTop: 0,
        },
    },
    actionBox: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            width: '100%',
        },
    },
    priceBox: {
        [theme.breakpoints.down('sm')]: {
            minWidth: 0,
            paddingRight: theme.spacing(1),
        },
    },
    priceLabel: {
        [theme.breakpoints.down('sm')]: {
            lineHeight: 1.1,
        },
    },
    priceValue: {
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0,
        },
    },
    actionButtons: {
        [theme.breakpoints.down('sm')]: {
            flex: '0 0 132px',
            maxWidth: 160,
        },
    },
    actionLink: {
        display: 'block',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        },
    },
    actionButton: {
        [theme.breakpoints.down('sm')]: {
            minHeight: 28,
            paddingTop: 4,
            paddingBottom: 4,
        },
    },
    showMoreButton: {
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'center',
            width: 'auto',
            minWidth: 0,
            marginTop: theme.spacing(1),
            paddingTop: 2,
            paddingBottom: 2,
        },
    },
    cardCollapse: {
        padding: theme.spacing(1),
    },
    img: {
        margin: theme.spacing(1),
        backgroundColor: '#ccc',
        borderRadius: theme.shape.borderRadius,
        overflow: "hidden",
        height: cardImageHeight,
        width: cardImageWidth,
        flex: '0 0 auto',
        '& a': {
            display: 'block',
            width: '100%',
            height: '100%',
        },
        '& > div': {
            width: '100%',
        },
        '& img': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        [theme.breakpoints.down('sm')]: {
            width: `calc(100% - ${theme.spacing(2)}px)`,
            height: 'auto',
            '& a': {
                height: 'auto',
            },
            '& img': {
                height: 'auto',
                objectFit: 'contain',
            },
        },
    }
}));
